module.exports = __webpack_public_path__ + "media/hph-23-12_powerhouse2.bcd35c17.mp4";